import { useState } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import OptionToggler from "../../../../parts/OptionToggler";
import { LinkPushCommunityComponent } from "./LinkPushCommunityComponent";
import ToolTip from "../../../../parts/tooltip";

export const PushPressCommunityCardActionsComponent = ({
  accountInfo,
  communityLinkFromDb,
  useLink,
  option,
  tooltip,
}) => {
  const { t } = useTranslation("dashboard");
  const {
    inAppCommunityEnabled: inAppCommunityEnabledFromDb = false,
    externalCommunityEnabled: externalCommunityEnabledFromDb = false,
  } = accountInfo;
  const initialState = {
    inAppCommunityEnabled: inAppCommunityEnabledFromDb,
    externalCommunityEnabled: externalCommunityEnabledFromDb,
    communityLink: communityLinkFromDb,
  };

  const [state, setState] = useState(initialState);

  const { inAppCommunityEnabled, externalCommunityEnabled, communityLink } =
    state;

  const pushPressCommunityOptions = [
    { label: t("pushPressCommunityCardActions.on"), value: true },
    { label: t("pushPressCommunityCardActions.off"), value: false },
  ];

  /**
   * Function to update the state of the toggles
   * @param {*} option
   * @param {*} value
   */

  const setCommunityToggler = (option, value) => {
    setState({
      ...state,
      [option]: value,
    });
  };

  /**
   * Render the tooltip
   * @param {*} body
   * @returns
   */
  const renderCommunityTooltip = (body) => {
    return (
      <ToolTip
        id="community-tooltip"
        className="help-tooltip"
        body={body}
        multiline
      >
        <div className="help-tooltip-container">?</div>
      </ToolTip>
    );
  };

  /**
   * Function to update the state of the input
   * @param {*} {target}
   */
  const handleChange = ({ target }) => {
    setState({
      ...state,
      [target.name]: target.value,
    });
  };

  return (
    <div className="push-community-card-actions">
      {useLink && externalCommunityEnabled && (
        <LinkPushCommunityComponent
          communityLink={communityLink}
          handleChange={handleChange}
        />
      )}
      <OptionToggler
        name={option}
        options={pushPressCommunityOptions}
        defaultValue={
          option === "inAppCommunityEnabled"
            ? inAppCommunityEnabled
            : externalCommunityEnabled
        }
        onSelectFn={(toggleValue) => {
          setCommunityToggler(option, toggleValue);
        }}
      />

      {renderCommunityTooltip(tooltip)}
    </div>
  );
};

PushPressCommunityCardActionsComponent.propTypes = {
  accountInfo: PropTypes.object.isRequired,
  communityLinkFromDb: PropTypes.string,
  useLink: PropTypes.bool.isRequired,
  option: PropTypes.string.isRequired,
  tooltip: PropTypes.string.isRequired,
};